import React, { FC } from 'react';
import { StaticPermission } from 'common/auth/Authorize';
import { DataTableRowAction } from '@utmost.co/utmost-design-system';
import { useStaticGlobalIntl } from 'src/utils/intl/useStaticGlobalIntl';

interface Props {
  onDelete?(uid: string): void;
  uid: string;
}

export const DeleteRateCardOption: FC<React.PropsWithChildren<Props>> = ({ onDelete, uid }) => {
  const [deleteLabel] = useStaticGlobalIntl('settings.engagements.rateCard.DeleteRateCard');

  return (
    <StaticPermission permissionName="RATE_CARD" permissionAction="DELETE">
      <DataTableRowAction dataTest="delete-rate-card" onClick={() => onDelete?.(uid)}>
        {deleteLabel}
      </DataTableRowAction>
    </StaticPermission>
  );
};
